import { styled } from '@mui/system';

export const FamilyMember = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  margin: '3px 0px'
});

export const Name = styled('span')({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontWeight: '400',
  fontSize: '0.875rem',
  lineHeight: '1.43',
  letterSpacing: '0.01071em',
  marginLeft: '4px',
  textDecoration: 'none'
});

export const Rp = styled('span')({
  marginLeft: '4px',
  color: '#565F6F'
});

export const Age = styled('span')({
  color: '#565F6F'
});